import { Moment } from 'moment';

export class ProviderNote {
	noteId: number;
	comment: string;
	addedBy: string;
	createdOn: Moment | string;
}

export interface NewProviderNote {
	comment: string;
}

